// @flow
export const loadText = function( url: string, shouldTryFromCache: boolean = false ): Promise<string> {
  return new Promise((resolve, reject) => {
    let cache = ( shouldTryFromCache ) ? '' : '?' + Math.random()
    url += cache

    const headers = new Headers({ 'Content-Type': 'text/plain' })
    const request = new Request( url, { headers: headers } )

    fetch(request)
      .then( function(response) { resolve(response.text()) } )
      .catch(reject)
  })
}

export const loadShaders = function( fragShaderURL: string, vertexShaderURL: string ): Promise<{fragment: string, vertex: string}> {
  return new Promise(resolve => {
    Promise.all([loadText(fragShaderURL), loadText(vertexShaderURL)])
      .then((shaders: Array<string>) => {
        resolve({fragment: shaders[0], vertex: shaders[1]})
      })
  })
}

export const loadImage = function(url: string, crossOrigin: boolean): Promise<HTMLImageElement> {
  return new Promise((resolve: (image: HTMLImageElement) => void, reject: () => void) => {
    const image = new Image()
    if (crossOrigin) image.crossOrigin = 'anonymous'
    image.onload = () => resolve(image)
    image.onerror = reject
    image.src = url
  })
}



// WEBPACK FOOTER //
// ./src/utils/netUtils.js